// extracted by mini-css-extract-plugin
export var banner = "_fs-0";
export var closeButton = "_fs-2";
export var greenCheckmark = "_fs-3";
export var hereLink = "_fs-4";
export var titleIcon = "_fs-1";